module.exports = __webpack_public_path__ + "static/media/back-popeyes-orange.703e0a52.svg";